var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");


var GlobalZRotationModel = require("./globalZRotationModel.js");
var GlobalZRotationView = require("./globalZRotationView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var GlobalZRotationController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);

};

lib_core.inherit(GlobalZRotationController, lib_core.Controller);
GlobalZRotationController.inject = {
    editor3d : Editor3d
};

module.exports = GlobalZRotationController;

GlobalZRotationController.prototype.handleId = "rotationGlobalZ";

GlobalZRotationController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new GlobalZRotationModel(editor3dModel, this.handleId, this.configuration);
};


GlobalZRotationController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new GlobalZRotationView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



